import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { INRCurrencyPipe } from '../../pipes/inrcurrency.pipe';

@Component({
  selector: 'app-selected-plan',
  templateUrl: './selected-plan.component.html',
  styleUrls: ['./selected-plan.component.scss'],
})
export class SelectedPlanComponent implements OnInit {

  @Input() dataSelected: any;
  @Input() goForward: any;
  @Input() formData: any;

  iciciQuote: boolean = false;
  hdfcQuote: boolean = false;
  monthlySelected: boolean = false;
  monthlyNoteChecked: boolean = false;

  showData = {
    "productName": "",
    "lifeCoverAmnt": "",
    "basePremium": "",
    "totalPremium": "",
    "premiumFreq": "",
    "pt": "",
    "ppt": "",
    "ciAddonAmnt": 0,
    "adAddonAmnt": 0,
    "ciAddonPremiumAmnt": 0,
    "adAddonPremiumAmnt": 0,
    "payFor": "",
    "payOut": "",
    "freq": "",
    "ccAddonAmnt": 0,
    "ccAddonPremiumAmnt": 0,
  }

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.monthlyNoteChecked = false;
    console.log(this.dataSelected, "dattatata");

    this.vvv(this.dataSelected);
  }

  vvv(data){
    let payFor;
    let payOut;
    if(data.productName === "ICICI Pru iProtect Smart"){
      this.iciciQuote = true;
      if(data.responseObj.premiumPaymentOption === "Regular Pay"){
        payFor = "Regular Pay For";
      }else{
        payFor = "Limited Pay For";
      }
  
      if(data.responseObj.deathBenefitOption === "Lump-Sum"){
        payOut = "Entire Amount in One time Payment"
      }
      else if(data.responseObj.deathBenefitOption === "Lump-Sum-Income"){
        payOut = "One Large Amount + Rest in Monthly Installments"
      }
      else if(data.responseObj.deathBenefitOption === "Income"){
        payOut = "Entire Amount in Monthly Installments"
      }
      else if(data.responseObj.deathBenefitOption === "Increasing Income"){
        payOut = "Entire Amount in Monthly Installment by increasing 10% every year"
      }
  
      this.showData = {
        "productName": data.responseObj.productName,
        "lifeCoverAmnt": data.responseObj.deathBenefit,
        "basePremium": data.responseObj.totalPremium,
        "totalPremium": data.responseObj.totalFirstPremiumShow,
        "premiumFreq": data.responseObj.modeOfPayment,
        "pt": data.responseObj.term + " Years",
        "ppt": data.responseObj.premiumPaymentTerm + " Years",
        "ciAddonAmnt": data.responseObj.cirsumAssured,
        "adAddonAmnt": data.responseObj.adbSumAssured,
        "ciAddonPremiumAmnt": data.responseObj.totalPremium_CI,
        "adAddonPremiumAmnt": data.responseObj.totalPremium_ADB,
        "payFor": payFor,
        "payOut": payOut,
        "freq": data.responseObj.modeOfPayment,
        "ccAddonAmnt": 0,
        "ccAddonPremiumAmnt": 0,
      }
      console.log("vvvv", this.showData);
      if(data.responseObj.modeOfPayment === "Monthly"){
        this.monthlySelected = true;
      } else {
        this.monthlySelected = false;
      }
    } else if(data.productName === "HDFC Life Click 2 Protect Life"){
      this.hdfcQuote = true;
      let resData = JSON.parse(data.responseObj.data);

      if(resData.POD.term === resData.POD.ppt){
        payFor = "Regular Pay For";
      }else{
        payFor = "Limited Pay For";
      }

      this.showData = {
        "productName": resData.prodname,
        "lifeCoverAmnt": resData.POD.DeathSA,
        "basePremium": "",
        "totalPremium": resData.totPremium,
        "premiumFreq": resData.POD.freq,
        "pt": resData.POD.term,
        "ppt": resData.POD.ppt,
        "ciAddonAmnt": 0,
        "adAddonAmnt": 0,
        "ciAddonPremiumAmnt": 0,
        "adAddonPremiumAmnt": 0,
        "payFor": payFor,
        "payOut": payOut,
        "freq": resData.POD.freq == "Annual" ? "Yearly" : resData.POD.freq,
        "ccAddonAmnt": 0,
        "ccAddonPremiumAmnt": 0,
      }

      if(resData.POD.freq === "Monthly"){
        this.monthlySelected = true;
      } else {
        this.monthlySelected = false;
      }

      this.showData.basePremium = resData.premium + resData.appTax;
      if(resData.rider){
        resData.rider.forEach(item => {
          console.log("fffff", item);
          if(item.name === "C4CI")
            this.showData.ciAddonPremiumAmnt = item.premium + item.tax;
            this.showData.ciAddonAmnt = item.sumAssured;
            if(item.name === "PPR_CC")
            this.showData.ccAddonPremiumAmnt = item.premium + item.tax;
            this.showData.ccAddonAmnt = item.sumAssured;
            if(item.name === "INAD")
            this.showData.adAddonPremiumAmnt = item.premium + item.tax;
            this.showData.adAddonAmnt = item.sumAssured;
        });
      }

    }

  }

  proceed(){
    this.modalCtrl.dismiss({
      dataSelected: this.dataSelected,
      goForward: true,
    });
  }

  close(){
    this.modalCtrl.dismiss({
      dataSelected: this.dataSelected,
      goForward: false,
    });
  }

}
